import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-lg-12 form-group" }
const _hoisted_2 = { for: "referral-address-line-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Address Line 1 ")
const _hoisted_5 = { class: "col-lg-12 form-group" }
const _hoisted_6 = { for: "referral-address-line-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Address Line 2 ")
const _hoisted_9 = { class: "col-lg-6 form-group" }
const _hoisted_10 = { for: "referral-zip" }
const _hoisted_11 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Zip ")
const _hoisted_13 = {
  key: 0,
  class: "col-lg-6 form-group"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "referral-zip" }, "ZIP-4 ", -1 /* HOISTED */)
const _hoisted_15 = {
  key: 1,
  class: "col-lg-6 form-group"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "referral-county" }, " County ", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  hidden: ""
}, "Select County", -1 /* HOISTED */)
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  disabled: "",
  value: null
}
const _hoisted_20 = { class: "col-lg-6 form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "referral-city" }, " City ", -1 /* HOISTED */)
const _hoisted_22 = { class: "col-lg-12 form-group" }
const _hoisted_23 = { for: "referral-state" }
const _hoisted_24 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" State ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select State", -1 /* HOISTED */)
const _hoisted_27 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.className} row`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        (_ctx.isPrimaryAddress)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Primary"))
          : _createCommentVNode("v-if", true),
        _hoisted_4
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.AddressLine1) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addressChanged('AddressLine1'))),
        placeholder: "Enter Address Line 1"
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.address.AddressLine1]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        (_ctx.isPrimaryAddress)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Primary"))
          : _createCommentVNode("v-if", true),
        _hoisted_8
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.AddressLine2) = $event)),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addressChanged('AddressLine2'))),
        placeholder: "Enter Address Line 2"
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.address.AddressLine2]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "M0060"))
          : _createCommentVNode("v-if", true),
        _hoisted_12
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "5",
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.AddressZipCode) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addressChanged('AddressZipCode'))),
        placeholder: "Enter Zip"
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_directive_number_only],
        [_vModelText, _ctx.address.AddressZipCode]
      ])
    ]),
    (_ctx.index == null && _ctx.showCountyFrzip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            maxlength: "4",
            type: "text",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.AddressZipCodeFour) = $event)),
            placeholder: "Enter Zip",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addressChanged('AddressZipCodeFour')))
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_directive_number_only],
            [_vModelText, _ctx.address.AddressZipCodeFour]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.index == null && _ctx.showCountyFrzip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addressChanged('AddressCounty'))),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.AddressCounty) = $event))
          }, [
            _hoisted_17,
            (_ctx.countyData?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.countyData, (ctyData, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: ctyData,
                    key: index
                  }, _toDisplayString(ctyData), 9 /* TEXT, PROPS */, _hoisted_18))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("option", _hoisted_19, "List is empty"))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.address.AddressCounty]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addressChanged('AddressCity'))),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.AddressCity) = $event)),
        placeholder: "Enter City"
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.address.AddressCity]
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("label", _hoisted_23, [
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "M0050"))
          : _createCommentVNode("v-if", true),
        _hoisted_25
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addressChanged('AddressStateCode'))),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.address.AddressStateCode) = $event))
      }, [
        _hoisted_26,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.addressStateCode, (addState, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: addState.value,
            key: index
          }, _toDisplayString(addState.text), 9 /* TEXT, PROPS */, _hoisted_27))
        }), 128 /* KEYED_FRAGMENT */))
      ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelSelect, _ctx.address.AddressStateCode]
      ])
    ])
  ], 2 /* CLASS */))
}